import Vue from 'vue'
import Vuex from 'vuex'
import alerts from './alerts/store'

import login from './login/store'
import incidencias from './incidencias/store'
import configuracion from './configuracion/store'
import gestion from './gestion/store'
import informes from './informes/store'
import chat from './chat/store'
import inmuebles from './inmuebles/store'

import api from '@/api/api'
Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    login,
    alerts,
    incidencias,
    configuracion,
    informes,
    chat,
    gestion,
    inmuebles
  },
  state: {
    version: '0.30.0',
    versionApi: '407',
    beforeRoute: null,
    currentRoute: null,
    miniVariant: true,
    navigationUser: false,
    dialogLeft: 48,
    title: 'Posventa Prinex',
    me: {},
    configuracionRolCliente: {},
    rutaAnulada: null,
    tubos: false,
    configuracionRolProveedor: {},
    agrupacionRolProveedor: null,
    subdominioRolProveedor: null,
    itemsPerPage: 50
  },
  mutations: {
    toggleMiniVariant (state) {
      state.miniVariant = !state.miniVariant
    },
    setDialogLeft (state, payload) {
      state.dialogLeft = payload
    },
    setMe (state, {me}) {
      state.me = me
    },
    setVersionWS (state, payload) {
      state.versionApi = payload
    },
    setConfiguracionRolCliente (state, payload) {
      state.configuracionRolCliente = payload
    },
    setConfiguracionRolProveedor (state, payload) {
      state.configuracionRolProveedor = payload
    },
    setAgrupacionRolProveedor (state, payload) {
      state.agrupacionRolProveedor = payload
    },
    setRutaAnulada (state, payload) {
      state.rutaAnulada = payload
    },
    setSubdominioRolProveedor (state, payload) {
      state.subdominioRolProveedor = payload
    },
    setItemsPerPage(state, payload) {
      console.log('cambia el items per page', payload)
      state.itemsPerPage = payload
    }
  },
  actions: {
    toggleMiniVariant ({ commit }) {
      commit('toggleMiniVariant')
    },
    setDialogLeft ({ commit }, payload) {
      commit('setDialogLeft', payload)
    },
    obtenerVersionWS ({commit}) {
      return new Promise((resolve/* , reject */) => {
        api.get('/varios/getWsVersion')
          .then(/* response */(response) => {
            commit('setVersionWS', response.data.version)
          })
          .catch(/* e */() => {
            resolve()
          })
      })
    },
    obtenerDatosSuscriptor ({commit}, payload) {
      const env = require('../../config/prod.env')
      const querystring = require('querystring')
      return new Promise((resolve, reject) => {
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_Admin/get_configuracion_subdominio_agrupacion_para_login',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                cod_subdominio_agrupacion: payload.cliente,
                cod_app: payload.codapp,
              }
            })
          }))
          .then (response => {
            let configuracion = response.data.result.data.data[0].configuraciones.data

            var configuracionClaveValor = configuracion.reduce(function(map, obj) {
              map[obj.CLAVE_CONFIGURACION] = obj.VALOR_CONFIGURACION
              return map
            }, {})

            if(payload.codapp === 11) {
              commit('setConfiguracionRolCliente', configuracionClaveValor)
            } else {
              commit('setConfiguracionRolProveedor', configuracionClaveValor)
              commit('setAgrupacionRolProveedor', response.data.result.data.data[0].ID_AGRUPACION)
              commit('setSubdominioRolProveedor', payload.cliente)
            }
            resolve(configuracionClaveValor)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarRutaAnulada({commit}, ruta) {
      commit('setRutaAnulada', ruta)
    }
  },
  getters: {
    title (state) {
      return state.title
    },
    miniVariant (state) {
      return state.miniVariant
    },
    navigationUser (state) {
      return state.navigationUser
    },
    beforeRoute (state) {
      return state.beforeRoute
    },
    currentRoute (state) {
      return state.currentRoute
    },
    getDialogLeft (state) {
      return state.dialogLeft
    },
    version (state) {
      return state.version
    },
    versionApi (state) {
      return state.versionApi
    },
    getMyUuid: (state) => state.me.uuid,
    getRutaAnulada: (state) => state.rutaAnulada,
    getTubos: (state) => state.tubos,
    getAgrupacionRolProveedor: (state) => state.agrupacionRolProveedor,
    getSubdominioRolProveedor: (state) => state.subdominioRolProveedor,
  }
})
